import { Building2, Check, Coins, Users } from "lucide-react";
import { useEffect, useState } from "react";

export function OrganizationSetupPage({ api, onActivated }) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activating, setActivating] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    api.organizationProvisioningStatus()
      .then((nextStatus) => {
        if (active) setStatus(nextStatus);
      })
      .catch((requestError) => {
        if (active) setError(requestError.message);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [api]);

  const activate = async () => {
    setActivating(true);
    setError("");
    try {
      await api.activateOrganization();
      setStatus((current) => ({ ...current, active: true }));
      onActivated?.();
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setActivating(false);
    }
  };

  if (loading) {
    return <div className="support-access-state">Preparando la organización…</div>;
  }

  if (!status) {
    return <div className="support-access-error">{error || "No pudimos abrir la organización."}</div>;
  }

  return (
    <div className="organization-setup-page">
      <header className="institution-heading">
        <span className="institution-logo">
          {status.organization.imageUrl
            ? <img src={status.organization.imageUrl} alt="" />
            : <Building2 size={28} />}
        </span>
        <div>
          <span className="support-access-eyebrow">TRIBUNALEA ORGANIZACIONES</span>
          <h1>{status.organization.name}</h1>
          <p>Activá el espacio compartido para trabajar con tu equipo.</p>
        </div>
      </header>

      {error ? <div className="support-access-error" role="alert">{error}</div> : null}

      <section className="organization-setup-card">
        <div className="organization-setup-copy">
          <span className="invitation-form-icon"><Building2 size={22} /></span>
          <div>
            <h2>Espacio de organización</h2>
            <p>La suite completa y un solo espacio compartido para tu equipo.</p>
          </div>
        </div>
        <div className="organization-setup-benefits">
          <span>
            <Users size={18} />
            <strong>
              {status.organization.maxAllowedMemberships === null
                ? `${status.organization.membersCount} miembros en Clerk`
                : `${status.organization.membersCount}/${status.organization.maxAllowedMemberships} miembros en Clerk`}
            </strong>
          </span>
          <span><Coins size={18} /><strong>Saldo de créditos compartido</strong></span>
          <span><Check size={18} /><strong>Todas las aplicaciones disponibles</strong></span>
          <span><Check size={18} /><strong>Datos, plantillas e historial compartidos</strong></span>
        </div>
        {status.canActivate ? (
          <button
            type="button"
            className="organization-setup-action"
            disabled={activating || status.active}
            onClick={activate}
          >
            {status.active ? <Check size={18} /> : <Building2 size={18} />}
            {status.active
              ? "Organización activada"
              : activating ? "Activando…" : "Activar Tribunalea Organizaciones"}
          </button>
        ) : (
          <p className="organization-setup-admin-note">
            Un administrador de la organización debe realizar la activación.
          </p>
        )}
        <small>
          Las funciones generales son abiertas. El uso de inteligencia artificial
          se paga con los créditos compartidos de la organización.
        </small>
        <small>
          Los recursos creados dentro de la organización serán compartidos con
          sus integrantes. Lo que ya tenés en Personal seguirá siendo privado y
          separado.
        </small>
      </section>
    </div>
  );
}
